<template>
  <div id="through-development">
    <div class="section padding-top padding-bottom over-hide">
      <div class="container">
        <div class="row page-title px-4 px-xl-2">
          <div class="col-12 col-lg-5 order-2 order-lg-1">
            <img
              src="@/assets/img/about/development.jpg"
              alt="get-the-response"
              class="img-fluid"
            />
          </div>
          <div class="col-12 col-lg-7 order-1 order-lg-2 padding-top-big">
            <div class="row">
              <div class="col-md-10 order-md-1 order-2 parallax-fade-top">
                <h1 class="no-break">
                  create a <span class="highlight">wow</span> user expreience
                </h1>
              </div>
              <div class="col-md-2 order-md-2 order-1 text-left">
                <span> THROUGH DEVELOPMENT</span>
              </div>
              <div class="col-12 order-3 parallax-fade-top mt-2 mt-sm-3">
                <p>
                  Your website speaks for you when no-one else is around. Give
                  it something <span class="highlight">nice</span> to say.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ParallaxEffect } from "@/components/utils";
export default {
  mounted() {
    ParallaxEffect(this.$el);
  }
};
</script>

<style lang="scss" scoped></style>
